export function getAWSPermissionToCheck(
  operationId: string,
  permissionsNamespace: string,
  preExistentPermissions: string[] | undefined
) {
  if (preExistentPermissions && preExistentPermissions.length > 0) {
    return preExistentPermissions;
  }

  return [`${permissionsNamespace}:${operationId}`];
}
